export function renderMobileRemoteUI({
  playIconSvg,
  pauseIconSvg,
  fullscreenEnterIconSvg,
  initialMuted = true,
  buildSoundIconMarkup
}) {
  document.documentElement.classList.add('mobile-remote-mode');
  document.body.classList.add('mobile-remote-mode');

  function bindPressedVisualState(buttonElement) {
    if (!buttonElement) return;

    const setPressed = () => buttonElement.classList.add('is-pressed');
    const clearPressed = () => buttonElement.classList.remove('is-pressed');

    buttonElement.addEventListener('pointerdown', setPressed, { passive: true });
    buttonElement.addEventListener('pointerup', clearPressed, { passive: true });
    buttonElement.addEventListener('pointercancel', clearPressed, { passive: true });
    buttonElement.addEventListener('pointerleave', clearPressed, { passive: true });

    // Fallback for browsers without Pointer Events.
    buttonElement.addEventListener('touchstart', setPressed, { passive: true });
    buttonElement.addEventListener('touchend', clearPressed, { passive: true });
    buttonElement.addEventListener('touchcancel', clearPressed, { passive: true });
  }

  const root = document.createElement('div');
  root.className = 'remote-mobile';

  const mobileIrBlaster = document.createElement('div');
  mobileIrBlaster.className = 'mobile-ir-blaster';

  const display = document.createElement('div');
  display.className = 'display';
  display.id = 'mdisp';
  display.textContent = 'CH --';

  const row1 = document.createElement('div');
  row1.className = 'row';

  const powerButton = document.createElement('button');
  powerButton.className = 'btn btn-lg btn-power';
  powerButton.id = 'mobilePowerButton';
  powerButton.type = 'button';
  powerButton.textContent = '⏻';

  const playButton = document.createElement('button');
  playButton.className = 'btn btn-lg btn-play';
  playButton.id = 'mPlayBtn';
  playButton.type = 'button';
  playButton.innerHTML = pauseIconSvg;

  bindPressedVisualState(powerButton);
  bindPressedVisualState(playButton);

  row1.appendChild(powerButton);
  row1.appendChild(playButton);

  const row2 = document.createElement('div');
  row2.className = 'row channel-row';

  const channelUpButton = document.createElement('button');
  channelUpButton.className = 'btn btn-lg btn-nav';
  channelUpButton.id = 'mobileChannelUpButton';
  channelUpButton.type = 'button';
  channelUpButton.textContent = '▲';

  const channelDownButton = document.createElement('button');
  channelDownButton.className = 'btn btn-lg btn-nav';
  channelDownButton.id = 'mobileChannelDownButton';
  channelDownButton.type = 'button';
  channelDownButton.textContent = '▼';

  bindPressedVisualState(channelUpButton);
  bindPressedVisualState(channelDownButton);

  row2.appendChild(channelUpButton);
  row2.appendChild(channelDownButton);

  const txtButton = document.createElement('button');
  txtButton.className = 'btn btn-sm btn-txt';
  txtButton.id = 'mTxtBtn';
  txtButton.type = 'button';
  txtButton.textContent = 'TV GUIDE';

  const muteButton = document.createElement('button');
  muteButton.className = 'btn btn-lg btn-mute';
  muteButton.id = 'mobileMuteButton';
  muteButton.type = 'button';
  muteButton.title = 'Mute';
  muteButton.setAttribute('aria-label', 'Mute');
  if (buildSoundIconMarkup) {
    muteButton.innerHTML = buildSoundIconMarkup(initialMuted);
  }

  const fullscreenButton = document.createElement('button');
  fullscreenButton.className = 'btn btn-lg btn-fullscreen';
  fullscreenButton.id = 'mobileFullscreenButton';
  fullscreenButton.type = 'button';
  fullscreenButton.title = 'Fullscreen';
  fullscreenButton.setAttribute('aria-label', 'Fullscreen');
  fullscreenButton.innerHTML = fullscreenEnterIconSvg;

  const utilityButtonRow = document.createElement('div');
  utilityButtonRow.className = 'row utility-button-row';

  const contactButton = document.createElement('button');
  contactButton.className = 'btn btn-sm btn-txt';
  contactButton.id = 'mContactBtn';
  contactButton.type = 'button';
  contactButton.textContent = 'CONTACT';

  const textButtonRow = document.createElement('div');
  textButtonRow.className = 'row text-button-row';

  bindPressedVisualState(txtButton);
  bindPressedVisualState(muteButton);
  bindPressedVisualState(fullscreenButton);
  bindPressedVisualState(contactButton);

  textButtonRow.appendChild(txtButton);
  textButtonRow.appendChild(contactButton);

  utilityButtonRow.appendChild(muteButton);
  utilityButtonRow.appendChild(fullscreenButton);

  root.appendChild(mobileIrBlaster);
  root.appendChild(display);
  root.appendChild(row1);
  root.appendChild(row2);
  root.appendChild(textButtonRow);
  root.appendChild(utilityButtonRow);

  // Clear body safely and mount.
  document.body.textContent = '';
  document.body.appendChild(root);

  return {
    root,
    elements: {
      mobileIrBlaster,
      display,
      powerButton,
      playButton,
      channelUpButton,
      channelDownButton,
      txtButton,
      muteButton,
      fullscreenButton,
      contactButton
    },
    setPlayPaused(isPaused) {
      playButton.innerHTML = isPaused ? playIconSvg : pauseIconSvg;
    },
    setMuted(isMuted) {
      if (buildSoundIconMarkup) {
        muteButton.innerHTML = buildSoundIconMarkup(isMuted);
      }
    }
  };
}

